import { render, staticRenderFns } from "./accurateInfo.vue?vue&type=template&id=eb688218&scoped=true"
import script from "./accurateInfo.vue?vue&type=script&lang=js"
export * from "./accurateInfo.vue?vue&type=script&lang=js"
import style0 from "./accurateInfo.vue?vue&type=style&index=0&id=eb688218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb688218",
  null
  
)

export default component.exports